import React from 'react'

function SectionFour() {
    return (
        <section className="section-4 mobile">
            <div className="container mt-5">
                <div className="container">
                    <div className="row text-center">
                        <div className="col">
                            <h4 className="typo-primary">Visit Our Store in the Spot on the Map Below</h4>
                            <p className="typo-secondary">See our store in every city on the spot and spen your good day there. See you soon!</p>
                        </div>
                    </div>
                    <div className="hero-map mobile" />
                </div>
            </div>
        </section>
    )
}

export default SectionFour